import { DATE_FORMAT } from "../../constants/Constant";
import Utility from "../../utility/Utility";
import { SHOW_MINIMUM_NO_LIST } from "../overtime/OvertimeConstants";
import moment from "moment";

export const AUDIT_LOG_MODULES = [
    {
        label: "All",
        value: "all"
    },
    {
        label: "Company Details",
        value: "tenant",
        fieldsToShow: {
            "Company Name": "organizationName"
        }
    },
    {
        label: "Employees",
        value: "user",
        fieldsToShow: {
            Name: "name",
            Type: "type"
        }
    },
    {
        label: "Custom Fields",
        value: "custom-field",
        fieldsToShow: {
            Name: "name",
            Type: "type",
            "Mapped To": "mappedWith"
        }
    },
    {
        label: "Shifts",
        value: "shift",
        fieldsToShow: {
            Name: "name",
            From: "from",
            To: "to"
        }
    },
    {
        label: "Overtime Policy",
        value: "overtime",
        fieldsToShow: {
            Name: "policyName",
            Description: "description",
            Activated: "activated"
        }
    },
    {
        label: "Overtime Payroll Multiplier",
        value: "overtime-multiplier",
        fieldsToShow: {
            "OT Multipliers": "overtimeMultiplierValues"
        }
    },
    {
        label: "Teams",
        value: "team",
        fieldsToShow: {
            Name: "name",
            Type: "type",
            Status: "status"
        }
    },
    {
        label: "Auto Clock Out",
        value: "auto-clock-out",
        className:"d-block",
        fieldsToShow: {
            "Clock Out":"clockOutTime",
            "Employees": "users"
        }
    },
    {
        label: "Timesheet",
        value: "timesheet",
        fieldsToShow: {
            'Task':'jobName',
            'Project':'projectName',
            'Employee':'employeeName',
            'Customer': "customerName",
            'Description': "description",
            'From':'fromDate',
            'To':'toDate',
            Status: "status"
        }
    },
    {
        label: "Goal",
        value: "goal",
        fieldsToShow: {
            "Name": "name",
            "Description": "description",
            "Start Date": "startDate",
            "Due Date": "dueDate",
            "Priority": "priority",
            "Applicable To": "applicableToNames",
        }
    },
    {
        label: "Appraisal",
        value: "appraisal",
        fieldsToShow: {
            "Due Date": "dueDate",
            "Frequency": "frequency",
        }
    },
    {
        label: "Expense Claims",
        value: "expense",
        fieldsToShow: {
            "Expense ID": "code",
            "Category": "category",
            "Total Amount": "totalAmount",
            "Status": "status"
        }
    },
    {
        label: "Expense Group",
        value: "expense-group",
        fieldsToShow: {
            "Name": "name"
        }
    },
    {
        label: "Expense Group Members",
        value: "expense-group-member",
        fieldsToShow: {
            "Group": "name",
            "Member": "member"
        }
    },
    {
        label: "User Role",
        value: "user_assigned_role",
        fieldsToShow: {
            Name: "name",
            Role: "roleName"
        }
    },
    {
        label: "Custom Field Dropdown Options",
        value: "custom_field_options_update",
        fieldsToShow: {
            Name: "name",
            Options: "values"
        }
    },
];

export const AUDIT_LOG_COLUMNS = [
    {
        name: "Action",
        key: "message",
        columnCode: "message",
        type: "text",
        width: 350
    },
    {
        name: "User",
        key: "createdBy",
        columnCode: "createdBy",
        type: "select",
        width: 200,
        renderer: function(data) {
            return (
                <>
                    {!Utility.isEmpty(data?.value) &&
                        <div className={`row fs-m border-radius-s data-grid-badge-color-${10 - data?.value?.length % 10}`} style={{ width: "auto", padding: "2px 6px" }}>
                            <div className="fs-r text-align-left display-block">
                                {data?.value}
                            </div>
                        </div>
                    }
                    {Utility.isEmpty(data?.value) && <>-</>}
                </>
            );
        }
    },
    {
        name: "Action Date",
        key: "createdAt",
        columnCode: "createdAt",
        type: "text",
        width: 180
    },
    {
        name: "Log",
        key: "log",
        columnCode: "log",
        type: "text",
        width: 320
    }
];

const CUSTOM_FIELD_MODULES = {
    employee_details: "Employee Details",
    payrun: "Payrun",
    payschedule: "Payschedule",
    compOff: "Compensatory Off"
}

class AuditLogUtils {
    static formatLogValue(module, valueKey, document, userNames, groups) {
        while (valueKey.includes(".")) {
            document = document[valueKey.substring(0, valueKey.indexOf("."))];
            valueKey = valueKey.substring(valueKey.indexOf(".") + 1);
        }

        const value = document[valueKey];

        let formattedValue = value;

        switch (typeof value) {
            case "boolean":
                formattedValue = value ? "True" : "False";
                break;
            default:
                break;
        }

        switch (module.value) {
            case "user":
                switch (valueKey) {
                    case "name":
                        formattedValue = `${document["firstName"]} ${document["lastName"]}`;
                        break;
                    case "type":
                        formattedValue = value === "CONTRACTOR" ? "Contractor" : "Employee";
                        break;
                    default:
                        break;
                }
                break;
            case "custom-field":
                switch (valueKey) {
                    case "mappedWith":
                        formattedValue = Array.isArray(value) ? value.map(cfm => CUSTOM_FIELD_MODULES[cfm]).join(", ") : "";
                        break;
                    default:
                        break;
                }
                break;
            case "overtime-multiplier":
                switch (valueKey) {
                    case "overtimeMultiplierValues":
                        formattedValue = Array.isArray(value) ? value.map(otm => otm.value).join(", ") : "";
                        break;
                    default:
                        break;
                }
                break;
            case "auto-clock-out": 
            switch(valueKey) {
                case "clockOutTime":
                    if(!Utility.isEmpty(value)) {
                        formattedValue = value.replace("Z","")
                        formattedValue = moment(formattedValue).format(DATE_FORMAT.YYYYMMDD_HHMM);
                    }
                    
                    break;
                case "users":
                    const popupDisplayValues = value?.map((e) => `${e}`).join(", ");
                    formattedValue = value?.slice(0, SHOW_MINIMUM_NO_LIST)?.map((e) => `${e}`).join(", ");
                    formattedValue  += value?.length > SHOW_MINIMUM_NO_LIST ? `...<u class="text-app fw-m d-flex" onclick="window.openUsersList('${Utility.encodeJSON(popupDisplayValues)}')">+${value?.length - SHOW_MINIMUM_NO_LIST} more</u>` : "";
                    break;
                    default:
                        break;
            }
            case "timesheet":
                switch(valueKey) {
                    case "fromDate":
                    case "toDate":
                        formattedValue = !Utility.isEmpty(value) ? moment((value)).format('hh:mm A'):'-';
                        break;
                    default:
                        formattedValue = !Utility.isEmpty(value) ? value : '-';
                        break;
                }                
                break;
            case "goal":
                switch (valueKey) {
                    case "startDate":
                        formattedValue = !Utility.isEmpty(value) ? new Date(parseInt(value)).toLocaleDateString() : '-';
                        break; 
                    case "dueDate":
                        formattedValue = !Utility.isEmpty(value) ? new Date(parseInt(value)).toLocaleDateString() : '-';
                        break;
                    case "applicableToNames":
                        const popupDisplayValues = value?.map((e) => `${e}`).join(", ");
                        formattedValue = value?.slice(0, SHOW_MINIMUM_NO_LIST)?.map((e) => `${e}`).join(", ");
                        formattedValue  += value?.length > SHOW_MINIMUM_NO_LIST ? `...<u class="text-app fw-m d-flex" onclick="window.openUsersList('${Utility.encodeJSON(popupDisplayValues)}')">+${value?.length - SHOW_MINIMUM_NO_LIST} more</u>` : "";
                        break;           
                    default:
                        formattedValue = !Utility.isEmpty(value) ? value : '-';
                        break;
                }
                break;
            case "appraisal":
                switch (valueKey) {
                    case "dueDate":
                        formattedValue = !Utility.isEmpty(value) ? new Date(parseInt(value)).toLocaleDateString() : '-';
                        break;                    
                    default:
                        formattedValue = !Utility.isEmpty(value) ? value : '-';
                        break;
                }
                break;
            case "expense-group-member":
                switch (valueKey) {
                    case "member":
                        formattedValue = Array.isArray(document.groupMembers) ? document.groupMembers
                        .filter((member) => userNames[member.userId])
                        .map((member) => userNames[member.userId])
                        .join(", ") : "-";
                        break;
                    case "name":
                        formattedValue = Array.isArray(document.groupMembers) && document.groupMembers.length > 0
                        ? groups[document.groupMembers[0].groupId] || "-" : "-";
                        break;
                    default:
                        formattedValue = !Utility.isEmpty(value) ? value : '-';
                        break;
                }
                break;
            case "user_assigned_role":
                formattedValue = !Utility.isEmpty(value) ? value : '-';
                break    
            default:
                break;
        }

        return formattedValue || "";
    }

    static getLogByModule(moduleId, document, userNames, groups) {
        const module = AUDIT_LOG_MODULES.find((m) => m.value === moduleId);

        if (document && module?.fieldsToShow) {
            return (
                `<table>
                    ${Object.entries(module.fieldsToShow).map(([key, valueKey]) => {
                        return (
                            `<tr>
                                <td class="fw-b ${module.className ? module.className:''} ">${key}:</td>
                                <td>${AuditLogUtils.formatLogValue(module, valueKey, document, userNames, groups)}</td>
                            </tr>`
                        )
                    }).join("")}
                </table>`
            )
        }
    }

    static getAuditLogRowData(auditLogs, users, userNames, groups) {
        const rowData = [];
        if (auditLogs && auditLogs.length > 0) {
            auditLogs.forEach((auditLog) => {
                const row = {
                    message: auditLog.message,
                    createdBy: users[auditLog.createdBy] || "",
                    createdAt: Utility.formatDate(auditLog.createdAt, DATE_FORMAT.YYYYMMDD),
                    log: AuditLogUtils.getLogByModule(auditLog.module, auditLog.updatedData, userNames, groups)
                };
                rowData.push(row);
            });
        }
    
        return rowData;
    }

    static pushModule(module) {
        if (module && AUDIT_LOG_MODULES.findIndex(m => m.value === module.value) === -1) {
            AUDIT_LOG_MODULES.push(module);
        }
    }
}

export default AuditLogUtils;
